"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shuffle = void 0;
// Source - https://stackoverflow.com/a/2450976
const shuffle = (array) => {
    let copy = [...array];
    let currentIndex = array.length;
    // While there remain elements to shuffle...
    while (currentIndex != 0) {
        // Pick a remaining element...
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [copy[currentIndex], copy[randomIndex]] = [copy[randomIndex], copy[currentIndex]];
    }
    return copy;
};
exports.shuffle = shuffle;
